import {Map, fromJS, List} from "immutable";

import {
    GET_COST_BREAKDOWNS_SUCCESS,
    GET_COST_BREAKDOWNS_REQUEST,
    GET_COST_BREAKDOWNS_ERROR,

    GET_COST_BREAKDOWN_REQUEST,
    GET_COST_BREAKDOWN_SUCCESS,
    GET_COST_BREAKDOWN_ERROR,

    CREATE_COST_BREAKDOWN_REQUEST,
    CREATE_COST_BREAKDOWN_SUCCESS,
    CREATE_COST_BREAKDOWN_ERROR,

    UPDATE_COST_BREAKDOWN_REQUEST,
    UPDATE_COST_BREAKDOWN_SUCCESS,
    UPDATE_COST_BREAKDOWN_ERROR,

    UPLOAD_COST_BREAKDOWN_FILES_REQUEST,
    UPLOAD_COST_BREAKDOWN_FILES_PROGRESS,
    UPLOAD_COST_BREAKDOWN_FILES_SUCCESS,
    UPLOAD_COST_BREAKDOWN_FILES_ERROR,

    DELETE_COST_BREAKDOWN_FILE_REQUEST,
    DELETE_COST_BREAKDOWN_FILE_SUCCESS,
    DELETE_COST_BREAKDOWN_FILE_ERROR,

    DELETE_COST_BREAKDOWN_REQUEST,
    DELETE_COST_BREAKDOWN_SUCCESS,
    DELETE_COST_BREAKDOWN_ERROR,

    CLEAN_COST_BREAKDOWNS
} from '../actions/cost-breakdowns';

const costBreakdowns = (state = Map({
  payload: List([]),
  isFetching: false,
    isUploading: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_COST_BREAKDOWNS_REQUEST:
      case GET_COST_BREAKDOWN_REQUEST:
      case CREATE_COST_BREAKDOWN_REQUEST:
      case UPDATE_COST_BREAKDOWN_REQUEST:
      case DELETE_COST_BREAKDOWN_FILE_REQUEST:
      case DELETE_COST_BREAKDOWN_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      case UPLOAD_COST_BREAKDOWN_FILES_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: true,
              error: action.error,
              percent: 0
          });
          return newState;

      // Progress
      case UPLOAD_COST_BREAKDOWN_FILES_PROGRESS:
          newState = state.merge({
              percent: action.percent
          });
          return newState;

      // Success
      case GET_COST_BREAKDOWNS_SUCCESS:
      case GET_COST_BREAKDOWN_SUCCESS:
      case CLEAN_COST_BREAKDOWNS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_COST_BREAKDOWN_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_COST_BREAKDOWN_SUCCESS:
      case UPLOAD_COST_BREAKDOWN_FILES_SUCCESS:
      case DELETE_COST_BREAKDOWN_FILE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  isUploading: false,
                  percent: 0,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_COST_BREAKDOWN_SUCCESS:
          updatedPayload = payload.filter( workReport => {
              return workReport.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_COST_BREAKDOWNS_ERROR:
      case GET_COST_BREAKDOWN_ERROR:
      case CREATE_COST_BREAKDOWN_ERROR:
      case UPDATE_COST_BREAKDOWN_ERROR:
      case UPLOAD_COST_BREAKDOWN_FILES_ERROR:
      case DELETE_COST_BREAKDOWN_FILE_ERROR:
      case DELETE_COST_BREAKDOWN_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default costBreakdowns;



// WEBPACK FOOTER //
// ./src/reducers/cost-breakdowns.js